import React from 'react';
type MarqueeProps = {
  items: string[];
  /** Seconds for one full loop. */
  duration?: number;
  className?: string;
  accentEvery?: number;
};

/** CSS-driven infinite marquee — cheap on mobile, pauses on hover. */
export function Marquee({
  items,
  duration = 34,
  className,
  accentEvery = 2
}: MarqueeProps) {
  const doubled = [...items, ...items];
  return <div className={`marquee-paused relative overflow-hidden border-y border-line bg-surface py-5 ${className ?? ''}`} aria-hidden="true" data-id="element-325" data-mp="2diq3i0pb2vtl">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap" style={{
      '--marquee-duration': `${duration}s`
    } as React.CSSProperties} data-id="element-326" data-mp="36a9pfsdaenza">
        {doubled.map((item, index) => <span key={`${item}-${index}`} className="flex items-center gap-10" data-id="element-327" data-mp="2x8acpc9b2625" data-mpi={index}>
            <span className={`font-display text-2xl font-extrabold uppercase tracking-tightest sm:text-4xl ${index % accentEvery === 1 ? 'text-brand' : 'text-ink'}`} data-id="element-328" data-mp="1pvrpraskm1zd">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rotate-45 bg-lav" data-id="element-329" data-mp="2ygxpy0t2whez" />
          </span>)}
      </div>
    </div>;
}